<ng-template #presaleBook let-modal>
  <div class="modal-header">
    <div class="modal-title fs-5">
      <span *ngIf="!bookingSuccessful">{{facilityConfig.getStartedPage.title}}</span>
      <span *ngIf="bookingSuccessful">Booking Confirmed!</span>
    </div>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dismiss()"></button>
  </div>
  <div class="modal-body text-center">
    <div class="container">
      <!-- Booking Form Content -->
      <div *ngIf="!bookingSuccessful">
        <div class="row mb-4 mt-4">
          <div class="col">
            <h4>{{facilityConfig.getStartedPage.title}}</h4>
          </div>
        </div>
        <!-- Prospect Information -->
        <div class="row mb-3" *ngIf="prospectInfo">
          <div class="col">
            <div class="prospect-info">
              <h5>Welcome, {{prospectInfo.FirstName}} {{prospectInfo.LastName}}!</h5>
              <p class="text-muted">Ready to book your spot?</p>
            </div>
          </div>
        </div>

        <!-- Session Details -->
        <div class="row mb-4" *ngIf="session">
          <div class="col">
            <div class="session-details">
              <h5>Session Details</h5>
              <div class="session-info">
                <div class="row">
                  <div class="col-12 mb-2">
                    <strong>What:</strong> {{session.Class?.Name || session.ClassName}}
                  </div>
                  <div class="col-12 mb-2">
                    <strong>When:</strong>
                    <span *ngIf="session.StartDate">{{session.StartDate | date:'EEE, MMM d, y'}} at {{session.StartTimeStr}}</span>
                  </div>
                  <div class="col-12" *ngIf="session.Studio?.Name">
                    <strong>Location:</strong> {{session.Studio?.Name}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col">
            <button type="button" class="btn btn-secondary w-100" (click)="book()">
              {{facilityConfig.getStartedPage.buttonText}}
            </button>
          </div>
        </div>

        <!-- Error Message -->
        <div class="row mb-3" *ngIf="errorMessage">
          <div class="col">
            <div class="alert alert-danger error-message" role="alert">
              <i class="fas fa-exclamation-triangle me-2"></i>
              {{errorMessage}}
            </div>
          </div>
        </div>
      </div>

      <!-- Success Content -->
      <div *ngIf="bookingSuccessful" class="success-content">
        <div class="row mb-4 mt-4">
          <div class="col">
            <div class="success-message">
              <h4>Thanks, {{prospectInfo.FirstName}}!</h4>
              <p class="mb-3">Your first class is booked!</p>
              <p class="text-muted mb-4">Download the app and create your profile to see the spot you've booked and modify it.</p>
            </div>
          </div>
        </div>

        <!-- App Store Buttons -->
        <div class="row mb-4">
          <div class="col-12">
            <div class="app-buttons">
              <div class="row">
                <div class="col-6">
                  <a href="{{appStoreUrl}}" target="_blank" class="btn btn-dark w-100 app-store-btn">
                    <i class="fab fa-apple"></i> App Store
                  </a>
                </div>
                <div class="col-6">
                  <a href="{{playStoreUrl}}" target="_blank" class="btn btn-dark w-100 play-store-btn">
                    <i class="fab fa-google-play"></i> Google Play
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Close Button -->
        <div class="row">
          <div class="col">
            <button type="button" class="btn btn-outline-secondary w-100" (click)="dismiss()">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
